import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDateTimePicker = _resolveComponent("BaseDateTimePicker")!

  return (_openBlock(), _createBlock(_component_BaseDateTimePicker, _mergeProps({
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event)))
  }, _ctx.$attrs), null, 16, ["model-value"]))
}